/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the OrderNoteUpdateRequestDTO interface.
 */
export function instanceOfOrderNoteUpdateRequestDTO(value) {
    return true;
}
export function OrderNoteUpdateRequestDTOFromJSON(json) {
    return OrderNoteUpdateRequestDTOFromJSONTyped(json, false);
}
export function OrderNoteUpdateRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'content': json['content'] == null ? undefined : json['content'],
    };
}
export function OrderNoteUpdateRequestDTOToJSON(json) {
    return OrderNoteUpdateRequestDTOToJSONTyped(json, false);
}
export function OrderNoteUpdateRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'content': value['content'],
    };
}
